import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";

interface EmptySectionProps {
  message?: string;
  accentColor?: string;
}

export const EmptySection: React.FC<EmptySectionProps> = ({
  message = "Nothing here yet.",
  accentColor,
}) => (
  <Box
    sx={{
      borderRadius: 3,
      border: "1px dashed",
      borderColor: accentColor ? alpha(accentColor, 0.2) : "divider",
      bgcolor: accentColor ? alpha(accentColor, 0.02) : "transparent",
      py: 5,
      px: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1.25,
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: 2,
        bgcolor: accentColor ? alpha(accentColor, 0.08) : "action.hover",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <InboxIcon
        sx={{
          fontSize: "1.25rem",
          color: accentColor ?? "text.disabled",
        }}
      />
    </Box>
    <Typography
      sx={{
        fontSize: "0.88rem",
        fontWeight: 600,
        color: "text.secondary",
        textAlign: "center",
      }}
    >
      {message}
    </Typography>
  </Box>
);
